// ---------------------------------------------------------------------------
// Domain events a page may announce to the guided-tour engine.
//
// Every name a guide waits on must be declared here AND emitted by at least one
// page. Both directions are enforced by scripts/check-guides.js (yarn
// check:guides), which is what stops a guide from hanging forever on an event
// nobody fires.
//
// Naming: "<area>.<thing>.<pastTenseVerb>". Past tense on purpose - these are
// announcements that something already happened, never requests.
// ---------------------------------------------------------------------------

export const COACH_EVENT = {
  // Settings
  workingHoursSaved: 'settings.workingHours.saved',
  campusProfileSaved: 'settings.campusProfile.saved',
  billingCenterCreated: 'settings.billingCenter.created',
  invoiceNumberingSaved: 'settings.invoiceNumbering.saved',
  taxConfigSaved: 'settings.taxConfig.saved',
  invoiceTemplateSaved: 'settings.invoiceTemplate.saved',
  brandingSaved: 'settings.branding.saved',
  paymentGatewayConnected: 'settings.paymentGateway.connected',

  // Team & roles
  teamMemberInvited: 'team.member.invited',
  customRoleCreated: 'team.role.created',

  // Spaces
  spaceCreated: 'spaces.space.created',
  seatsAdded: 'spaces.seats.added',
  floorPlanCreated: 'spaces.floorPlan.created',

  // Members & companies
  memberCreated: 'members.member.created',
  companyCreated: 'members.company.created',
  subscriptionCreated: 'members.subscription.created',

  // Plans
  planCreated: 'plans.plan.created',

  // Meeting rooms
  meetingRoomCreated: 'meetingRooms.room.created',
  meetingRoomBooked: 'meetingRooms.booking.created',

  // Billing
  invoiceCreated: 'billing.invoice.created',
  paymentRecorded: 'billing.payment.recorded',

  // Leads
  leadCreated: 'leads.lead.created',
  proposalSent: 'leads.proposal.sent',

  // Front desk
  visitorCheckedIn: 'frontDesk.visitor.checkedIn',
  visitorInvited: 'frontDesk.visitor.invited',
  memberCheckedIn: 'frontDesk.member.checkedIn',
  serviceRequestCreated: 'frontDesk.serviceRequest.created',
  serviceRequestResolved: 'frontDesk.serviceRequest.resolved',

  // Community
  postPublished: 'community.post.published',
  eventCreated: 'community.event.created',

  // Generic UI signals. Use sparingly - a domain event is almost always better,
  // because it survives a redesign of the dialog that produced it.
  dialogSaved: 'ui.dialog.saved',
};

const KNOWN = new Set(Object.values(COACH_EVENT));

export function isKnownCoachEvent(name) {
  return KNOWN.has(name);
}

export const ALL_COACH_EVENTS = Object.freeze([...KNOWN]);
